export const parseTableFormat = (data, parseStatus = false) => {
  const lines = data.split('\n')

  let html = ''
  let tableBuffer = []

  const STATUS_WORDS = ['Fixed', 'Acknowledged', 'Mitigated', 'N/A', 'Unresolved']

  const wrapStatusIfExact = text => {
    if (!parseStatus) return text

    const trimmed = text.trim()
    if (!STATUS_WORDS.includes(trimmed)) return trimmed

    const className = trimmed.toLowerCase().replace('/', '').replace(/\s+/g, '-')

    return `<span class="status status-${className}">${trimmed}</span>`
  }

  const flushTable = () => {
    if (tableBuffer.length === 0) return

    const rows = tableBuffer.map(line =>
      line
        .trim()
        .slice(1, -1)
        .split('|')
        .map(cell => wrapStatusIfExact(cell)),
    )

    const header = rows[0]
    const bodyRows = rows.slice(1)

    html += `
      <table>
        <thead>
          <tr>${header.map(cell => `<th>${cell.trim()}</th>`).join('')}</tr>
        </thead>
        <tbody>
          ${bodyRows
            .map(row => `<tr>${row.map(cell => `<td>${cell}</td>`).join('')}</tr>`)
            .join('')}
        </tbody>
      </table>
    `

    tableBuffer = []
  }

  for (let line of lines) {
    const trimmed = line.trim()

    const isTableLine =
      trimmed.startsWith('|') && trimmed.endsWith('|') && !/^[-+| ]+$/.test(trimmed)

    const isSeparatorLine = /^[-+| ]+$/.test(trimmed)

    if (isTableLine) {
      tableBuffer.push(trimmed)
    } else if (isSeparatorLine) {
      continue
    } else {
      flushTable()

      if (trimmed.length > 0) {
        html += `<p>${trimmed}</p>`
      }
    }
  }

  flushTable()

  return html
}
